<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts" setup>
import { RoutesDefaults } from '@/Pejer/defaults'
import { NavigationsObject, RouteDefinition } from 'embeddables/src/Route'
import { Separator } from 'pejer/src/components/ui/separator'

defineProps<{
  routeDefinitions?: RouteDefinition[]
  currentRouteName?: string
}>()

defineEmits<{
  (e: 'navigate', route: NavigationsObject): void
}>()
</script>
<template>
  <nav class="flex w-full text-sm mb-1 justify-between sticky top-0 bg-white z-10">
    <div class="flex items-center gap-1 overflow-x-auto max-w-full text-sm">
      <div
        class="flex items-center gap-1 h-full"
        v-for="(route, index) in routeDefinitions"
        :key="route.routeName ?? index"
      >
        <Separator v-if="index !== 0" orientation="vertical" class="h-5" />
        <div
          class="flex items-center w-fit hover:bg-slate-100 p-2 gap-2 rounded-t-md cursor-pointer group hover:px-2 h-full"
          :class="{
            'border-primary font-semibold border-b-2 px-2':
              route.routeName && currentRouteName === route.routeName,
          }"
          @click="$emit('navigate', route as NavigationsObject)"
        >
          <component
            v-if="RoutesDefaults[route.path]"
            :is="RoutesDefaults[route.path].icon"
            class="w-4 h-4 group-hover:scale-105 transition-all duration-100"
          />
          <h1
            class="text-black whitespace-nowrap group-hover:scale-[102%] transition-all duration-100"
          >
            {{ route.displayText }}
          </h1>
        </div>
      </div>
    </div>
    <slot name="after"></slot>
  </nav>
</template>
